// import $ from 'expose-loader?exposes=$,jQuery!jquery';

// import axios from 'axios';
// axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

import Config from './utilities/Config.js';
import Breakpoint from './utilities/Breakpoint.js';

import ImagesLoaded from './modules/ImagesLoaded.js';
import Click from './modules/Click.js';
import ScrollTo from './modules/ScrollTo.js';
import Obfuscate from './modules/Obfuscate.js';
import LinkTransition from './modules/LinkTransition.js';
import FixedHeader from './modules/FixedHeader.js';
import InView from './modules/InView.js';
import SwiperSlider from './modules/SwiperSlider.js';
import Intro from './modules/Intro.js';
import Hero from './modules/Hero.js';
import Form from './modules/Form.js';
import Callout from './modules/Callout.js';
import ContactForm from './modules/ContactForm.js';

Config();
Breakpoint();

const modules = {
  imagesLoaded: ImagesLoaded(),
  click: Click(),
  scrollTo: ScrollTo(),
  obfuscate: Obfuscate(),
  linkTransition: LinkTransition(),
  hero: Hero(),
  intro: Intro(),
  swiperSlider: SwiperSlider(),
  form: Form(),
  contactForm: ContactForm(),
  inview: InView(),
  fixedHeader: FixedHeader(),
  callout: Callout(),
};
Object.values(modules).forEach((module) => {
  module.init();
});
